import React, { useEffect, useState } from 'react';
import ItemCost from './ItemCost/ItemCost';
import Panel from 'Components/Panel/Panel';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import CostFix from './CostFix/CostFix';
import HistoryChangePanel from './HistoryChangePanel/HistoryChangePanel';
import ItemsYearReplicate from './ItemsYearReplicate/ItemsYearReplicate';
import FilterItemCost from './FilterItemCost/FilterItemCost';
import FilterCostFix from './FilterCostFix/FilterCostFix';

const CostPanel = () => {
    useEffect(() => {
        document.title = "Redech | Custos fixos"
    }, [])

    const [itemCostIdSelected, setItemCostIdsSelected] = useState([]);
    const [showFilterPanelItem, setShowFilterPanelItem] = useState(false);
    const [isActiveFilterItems, setIsActiveFilterItems] = useState('S');
    const [comboBoxYear, setComboBoxYear] = useState(new Date());
    const [showHistoryChangePanel, setShowHistoryChangePanel] = useState(false);
    const [showItemsYearReplicate, setShowItemsYearReplicate] = useState(false);

    const [reloadItemCost, setReloadItemCost] = useState(false);

    const mainPanelStyle = {
        display: 'flex',
        flexDirection: 'row',
    };

    const panelItemCostStyle = {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '100%',
        maxWidth: '100%'
    };

    const panelCostFixStyle = {
        display: 'flex',
        flexDirection: 'column',
        borderLeft: 'solid 2px #ccc',
    };

    return (
        <>
            <LayoutDefault>
                <ItemsYearReplicate
                    onUpdateShowItemsYearReplicate={setShowItemsYearReplicate}
                    onUpdateReloadItemCost={setReloadItemCost}
                    showItemsYearReplicate={showItemsYearReplicate}
                />
                <HistoryChangePanel
                    comboBoxYear={comboBoxYear}
                    itemCostIdSelected={itemCostIdSelected}
                    onUpdateShowHistoryChangePanel={setShowHistoryChangePanel}
                    showHistoryChangePanel={showHistoryChangePanel}
                />

                <Panel style={mainPanelStyle} className={'main-modal two left'}>
                    <Panel style={panelItemCostStyle}>
                        <ItemCost
                            itemCostIdSelected={itemCostIdSelected}
                            isActiveFilterItems={isActiveFilterItems}
                            comboBoxYear={comboBoxYear}
                            reloadItemCost={reloadItemCost}
                            showItemsYearReplicate={showItemsYearReplicate}
                            showHistoryChangePanel={showHistoryChangePanel}
                            onUpdateItemCostIdsSelected={setItemCostIdsSelected}
                            onUpdateShowFilterMonthPanelItem={setShowFilterPanelItem}
                            onUpdateShowHistoryChangePanel={setShowHistoryChangePanel}
                            onUpdateShowItemsYearReplicate={setShowItemsYearReplicate}
                            onUpdateReloadItemCost={setReloadItemCost}
                            showFilterMonthPanelItem={showFilterPanelItem}
                            onUpdateIsActiveFilterItems={setIsActiveFilterItems}
                            onUpdateComboBoxYear={setComboBoxYear}
                        />
                    </Panel>
                </Panel>
                <Panel style={panelCostFixStyle} className={'main-modal two right'}>
                    <CostFix
                        itemCostIdSelected={itemCostIdSelected}
                    />
                </Panel>
            </LayoutDefault>
        </>
    );
};

export default CostPanel;
